var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.736,
    height: 70.584,
    viewBox: "0 0 96.736 70.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M32.419,0V7.261h-8.5V70.584H39.671V48.22H56.422V70.584H72.3V7.261H63.674V0Z",
    fill: "#20221d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    width: 6.878,
    height: 7.011,
    transform: "translate(51.546 6.981)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26",
    "data-name": "Rect\\xE1ngulo 26",
    width: 6.878,
    height: 6.885,
    transform: "translate(37.67 34.515)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_27",
    "data-name": "Rect\\xE1ngulo 27",
    width: 6.878,
    height: 6.761,
    transform: "translate(37.67 20.874)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_28",
    "data-name": "Rect\\xE1ngulo 28",
    width: 6.878,
    height: 7.011,
    transform: "translate(37.67 6.981)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_29",
    "data-name": "Rect\\xE1ngulo 29",
    width: 6.878,
    height: 6.885,
    transform: "translate(51.546 34.515)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_30",
    "data-name": "Rect\\xE1ngulo 30",
    width: 6.878,
    height: 6.761,
    transform: "translate(51.546 20.874)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_31",
    "data-name": "Rect\\xE1ngulo 31",
    width: 20.926,
    height: 40.936,
    transform: "translate(0 29.649)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32",
    "data-name": "Rect\\xE1ngulo 32",
    width: 6.878,
    height: 7.011,
    transform: "translate(7.024 34.453)",
    fill: "#fdb54e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_33",
    "data-name": "Rect\\xE1ngulo 33",
    width: 6.878,
    height: 7.011,
    transform: "translate(26.948 34.453)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_34",
    "data-name": "Rect\\xE1ngulo 34",
    width: 6.878,
    height: 7.011,
    transform: "translate(7.024 48.22)",
    fill: "#fdb54e"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_35",
    "data-name": "Rect\\xE1ngulo 35",
    width: 6.878,
    height: 7.011,
    transform: "translate(26.948 48.22)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_36",
    "data-name": "Rect\\xE1ngulo 36",
    width: 20.926,
    height: 40.936,
    transform: "translate(75.81 29.649)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_37",
    "data-name": "Rect\\xE1ngulo 37",
    width: 6.878,
    height: 7.011,
    transform: "translate(62.938 34.453)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_38",
    "data-name": "Rect\\xE1ngulo 38",
    width: 6.878,
    height: 7.011,
    transform: "translate(82.834 34.453)",
    fill: "#fdb54e"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_39",
    "data-name": "Rect\\xE1ngulo 39",
    width: 6.878,
    height: 7.011,
    transform: "translate(62.938 48.22)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_40",
    "data-name": "Rect\\xE1ngulo 40",
    width: 6.878,
    height: 7.011,
    transform: "translate(82.834 48.22)",
    fill: "#fdb54e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon);
export default __webpack_public_path__ + "static/media/hotelIcon.8c1a0e23ba2a2fbdd371983649c5b9a0.svg";
export { ForwardRef as ReactComponent };